import React, { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// hooks
import useUser from '../hooks/auth/useUser';

type PrivateRouteProps = {
    roles?: string[];
};


const PrivateRoute = ({ roles }: PrivateRouteProps) => {
    let location = useLocation();

    const { user, loading } = useUser();

    
    if (loading) {
        return <div>Memuat...</div>;
    }

    
    if (!user) {
        return <Navigate to={'/auth/login'} state={{ from: location }} replace />;
    }

    
    if (roles && user.role && !roles.includes(user.role)) {
        
        return <Navigate to={{ pathname: '/' }} replace />;
    }
    
    return (
        <Suspense fallback={<div>Memuat...</div>}>
            <Outlet />
        </Suspense>
    );
};

export default PrivateRoute;